var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2600_4060)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7934 47.8633H47.8125C48.143 49.4637 48.7653 51.0629 49.6751 52.6628C49.7664 52.8229 49.8473 52.989 49.9168 53.16C49.9168 53.1606 49.9168 53.1612 49.9174 53.1618C50.382 54.314 50.7246 55.4667 50.9475 56.6189C50.959 56.6763 50.9644 56.7343 50.9644 56.7911H54.9809C55.982 56.7911 56.7934 55.9797 56.7934 54.9786V47.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7887 56.7911H49.1313C48.9295 55.8075 48.631 54.8245 48.2341 53.8409L48.0976 53.56C47.0179 51.6611 46.2996 49.7622 45.9491 47.8633H34.6367C34.9672 49.4637 35.5895 51.0629 36.4994 52.6628C36.5906 52.8229 36.6716 52.989 36.7404 53.16C36.741 53.1606 36.741 53.1612 36.7416 53.1618C37.2062 54.314 37.5488 55.4667 37.7717 56.6189C37.7832 56.6763 37.7887 56.7343 37.7887 56.7911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6162 56.7911H35.9594C35.7576 55.8075 35.4586 54.8245 35.0622 53.8409L34.9257 53.56C33.846 51.6611 33.1277 49.7622 32.7773 47.8633H21.4648C21.7953 49.4637 22.4176 51.0629 23.3275 52.6628C23.4187 52.8229 23.4997 52.989 23.5686 53.16C23.5692 53.1606 23.5692 53.1612 23.5698 53.1618C24.0344 54.314 24.3763 55.4667 24.5999 56.6189C24.6113 56.6763 24.6168 56.7343 24.6162 56.7911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4404 56.7911H22.7836C22.5818 55.8075 22.2828 54.8245 21.8864 53.8409L21.7499 53.56C20.6696 51.6611 19.9519 49.7622 19.6015 47.8633H8.28906C8.61954 49.4637 9.24183 51.0629 10.1517 52.6628C10.2429 52.8229 10.3233 52.989 10.3928 53.16C10.3934 53.1606 10.3934 53.1612 10.394 53.1618C10.8586 54.314 11.2005 55.4667 11.4241 56.6189C11.4356 56.6763 11.441 56.7343 11.4404 56.7911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20703 47.8633V54.9786C1.20703 55.9797 2.01843 56.7911 3.01953 56.7911H9.61099C9.4092 55.8075 9.11014 54.8245 8.7138 53.8409L8.57726 53.56C7.49701 51.6611 6.77926 49.7622 6.42884 47.8633H1.20703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7914 35.8926H50.4694C50.2712 36.4188 50.0519 36.9456 49.812 37.4725C49.7987 37.5015 49.7842 37.5299 49.7679 37.5571C48.0962 40.3888 47.3688 43.2205 47.5615 46.0516H56.7914V35.8926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20703 35.8926V46.0516H6.20651C6.0162 42.9263 6.82639 39.8015 8.66184 36.6762C8.78026 36.4146 8.89324 36.1536 9.00078 35.8926H1.20703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1753 35.8926H10.9498C10.7517 36.4188 10.5324 36.9456 10.2925 37.4725C10.2792 37.5015 10.2641 37.5299 10.2478 37.5571C8.57607 40.3888 7.84926 43.2205 8.04199 46.0516H19.381C19.1907 42.9263 20.0009 39.8015 21.8369 36.6762C21.9553 36.4146 22.0677 36.1536 22.1753 35.8926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.351 35.8926H24.1256C23.9275 36.4188 23.7081 36.9456 23.4683 37.4725C23.455 37.5015 23.4399 37.5299 23.4242 37.5571C21.7518 40.3888 21.025 43.2205 21.2178 46.0516H32.5568C32.3665 42.9263 33.1766 39.8015 35.0127 36.6762C35.1311 36.4146 35.2435 36.1536 35.351 35.8926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.519 35.8926H37.2936C37.0954 36.4188 36.8761 36.9456 36.6363 37.4725C36.623 37.5015 36.6085 37.5299 36.5922 37.5571C34.9198 40.3888 34.193 43.2205 34.3857 46.0516H45.7247C45.5344 42.9263 46.3446 39.8015 48.1807 36.6762C48.2991 36.4146 48.4121 36.1536 48.519 35.8926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7915 23.9199H51.122C52.0832 27.3063 52.024 30.6932 51.0664 34.0796H56.7915V23.9199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20703 34.0796H9.65268C10.6997 30.6932 10.771 27.3069 9.70524 23.9199H1.20703V34.0796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8798 23.9199H11.6019C12.5637 27.3063 12.5039 30.6932 11.5469 34.0796H22.8279C23.8743 30.6932 23.9456 27.3069 22.8798 23.9199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0523 23.9199H24.7737C25.7356 27.3063 25.6764 30.6932 24.7188 34.0796H35.9998C37.0462 30.6932 37.1175 27.3069 36.0523 23.9199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2242 23.9199H37.9462C38.9074 27.3063 38.8482 30.6932 37.8906 34.0796H49.1716C50.218 30.6932 50.2893 27.3069 49.2242 23.9199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7918 11.9492H47.9039C47.7849 14.8045 48.4688 17.6592 49.8058 20.5139C50.0662 21.0449 50.3006 21.5766 50.5091 22.1083H56.7918V11.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20703 11.9492V22.1083H9.02555C8.90895 21.8406 8.78449 21.5718 8.65278 21.3035C8.65037 21.2987 8.64795 21.2939 8.64614 21.289C7.18707 18.1758 6.44214 15.0625 6.55874 11.9492H1.20703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7337 11.9492H8.38439C8.26537 14.8045 8.94928 17.6592 10.2857 20.5139C10.5461 21.0449 10.7805 21.5766 10.9896 22.1083H22.2005C22.0839 21.8406 21.9594 21.5718 21.8277 21.3035C21.8253 21.2987 21.8229 21.2939 21.8211 21.289C20.362 18.1758 19.6171 15.0625 19.7337 11.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9055 11.9492H21.5563C21.4372 14.8045 22.1212 17.6592 23.4576 20.5139C23.7186 21.0449 23.9524 21.5766 24.1614 22.1083H35.3729C35.2557 21.8406 35.1313 21.5718 34.9996 21.3035C34.9972 21.2987 34.9953 21.2939 34.9929 21.289C33.5339 18.1758 32.7889 15.0625 32.9055 11.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0819 11.9492H34.732C34.613 14.8045 35.2969 17.6592 36.6334 20.5139C36.8944 21.0449 37.1288 21.5766 37.3372 22.1083H48.5487C48.4315 21.8406 48.3077 21.5718 48.1754 21.3035C48.1729 21.2987 48.1711 21.2939 48.1687 21.289C46.7096 18.1758 45.9653 15.0625 46.0819 11.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.20703 10.1358H6.72489C7.00884 8.20063 7.63597 6.26609 8.64251 4.33095L8.69145 4.23972C9.2497 3.22895 9.68349 2.21878 9.98376 1.20801H3.01953C2.01843 1.20801 1.20703 2.0194 1.20703 3.02051V10.1358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3548 1.20801C51.3548 1.28776 51.3445 1.36872 51.3221 1.44907C50.9844 2.6713 50.4745 3.89413 49.7996 5.11576L49.7718 5.16772C48.9109 6.82374 48.3599 8.48036 48.0898 10.1358H56.7923V3.02051C56.7923 2.0194 55.9809 1.20801 54.9798 1.20801H51.3548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1796 1.20801C38.1796 1.28776 38.1693 1.36872 38.147 1.44907C37.8092 2.6713 37.2993 3.89413 36.6245 5.11576L36.5967 5.16772C35.7357 6.82374 35.1841 8.48036 34.9141 10.1358H46.2452C46.5286 8.20063 47.1557 6.26609 48.1622 4.33095L48.2112 4.23972C48.7694 3.22895 49.2032 2.21878 49.5035 1.20801H38.1796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0077 1.20801C25.0077 1.28776 24.9974 1.36872 24.9751 1.44907C24.6374 2.6713 24.1274 3.89413 23.4526 5.11576L23.4248 5.16772C22.5639 6.82374 22.0122 8.48036 21.7422 10.1358H33.0733C33.3567 8.20063 33.9838 6.26609 34.9904 4.33095L35.0393 4.23972C35.5975 3.22895 36.0313 2.21878 36.3316 1.20801H25.0077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8358 1.20801C11.8358 1.28776 11.825 1.36872 11.8032 1.44907C11.4655 2.6713 10.9556 3.89413 10.2807 5.11576L10.2529 5.16772C9.39138 6.82374 8.84038 8.48036 8.57031 10.1358H19.9015C20.1848 8.20063 20.8119 6.26609 21.8185 4.33095L21.8674 4.23972C22.4257 3.22895 22.8595 2.21878 23.1597 1.20801H11.8358Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2600_4060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextile);
export default __webpack_public_path__ + "static/media/Textile.3e5f44ece76042c3ff137c3dd695fa2f.svg";
export { ForwardRef as ReactComponent };